import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HomeService } from 'src/home/home.service';
import { Provider } from 'src/models/Provider.interface';
import { ProviderFormModalComponent } from '../provider-form-modal/provider-form-modal.component';
import Swal from 'sweetalert2';
import { ProviderUpdateModalComponent } from '../provider-update-modal/provider-update-modal.component';
import { MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { PaginatorService } from 'src/home/paginator.service';
import { AuthService } from '../../../auth/auth.service';
import { ProvidersService } from '../services/providers.service';

@Component({
  selector: 'app-providers',
  templateUrl: './providers.component.html',
  styleUrls: ['./providers.component.css'],
  providers: [{ provide: MatPaginatorIntl, useClass: PaginatorService }],
})
export class ProvidersComponent implements OnInit {
  providers: Provider[] = [];
  displayedProviders: Provider[] = [];
  pageSizeOptions: number[] = [10, 20, 50];
  totalProviders: number = 0;
  pageSize = 10;
  pageIndex = 0;

  public isLoading: boolean = false;
  public userRole: string = '';

  constructor(
    private dialog: MatDialog,
    private authService: AuthService,
    private providersService: ProvidersService
  ) { }

  ngOnInit(): void {
    this.handleLoadProviders();
    this.userRole = this.authService.getCurrentUserRole();

    this.providersService.rolEmitter.subscribe((action) => {
      if (action === 'refresh') {
        this.handleLoadProviders();
      }
    });
  }

  openProviderFormModal(): void {
    const dialogRef = this.dialog.open(ProviderFormModalComponent, {
      width: '70%',
      maxWidth: '600px',
      data: { title: 'Agregar Proveedor' },
    });

    dialogRef.afterClosed().subscribe((newProvider) => {
      if (newProvider) {
        this.handleCreateProvider(newProvider);
      }
    });
  }

  handleLoadProviders(): void {
    this.isLoading = true;
    this.providersService.getListProviders(1).subscribe(
      (data) => {
        this.isLoading = false;
        this.providers = data.results;
        this.totalProviders = this.providers.length;
        this.updateDisplayedProviders();
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  handlePageEvent(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.updateDisplayedProviders();
  }

  updateDisplayedProviders(): void {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.displayedProviders = this.providers.slice(startIndex, endIndex);
  }

  handleCreateProvider(newProvider: Provider): void {
    this.isLoading = true;
    this.providersService.createProvider(newProvider).subscribe(
      () => {
        this.isLoading = false;
        Swal.fire({
          text: 'Proveedor creado exitosamente',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#4caf50',
        });
        this.handleLoadProviders();
      },
      (error: any) => {
        this.isLoading = false;
        Swal.fire({
          text: 'Error al crear proveedor. Por favor, inténtalo de nuevo más tarde.',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
      }
    );
  }

  openUpdateModal(provider: Provider): void {
    const dialogRef = this.dialog.open(ProviderUpdateModalComponent, {
      width: '70%',
      maxWidth: '400px',
      data: { provider: provider },
    });

    dialogRef.afterClosed().subscribe((selectedRole) => {
      if (selectedRole) {
        this.handleUpdateProvider(selectedRole);
      }
    });
  }

  handleUpdateProvider(provider: Provider): void {
    this.isLoading = true;
    this.providersService
      .updateProvider(provider.id, {
        type: provider.type,
        status: provider.status,
      })
      .subscribe(
        () => {
          this.isLoading = false;
          console.log('Proveedor actualizado exitosamente');
        },
        (error) => {
          this.isLoading = false;
          console.error('Error al actualizar el proveedor:', error);
        }
      );
  }

}